module.exports = __webpack_public_path__ + "static/media/Never_Lug_Arrow.423b2ac2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/registry/Never_Lug_Arrow.svg
// module id = 1060
// module chunks = 40